/**
 * Transform object into a query string.
 * @param {Object[]} obj - The object to be transformed.
 * @returns {string} - Query string.
 */

export const toQueryString = obj => {
  let parts = [];
  if (!obj || !Object.keys(obj).length) {
    return false;
  }
  for (let i in obj) {
    if (obj.hasOwnProperty(i)) {
      if (obj[i] !== null && typeof obj[i] !== "undefined" && obj[i].constructor.name === "Object" && Object.keys(obj[i]).length) {
        for (let k in obj[i]) {
          parts.push(encodeURIComponent(k) + "=" + encodeURIComponent(obj[i][k]));
        }
      } else {
        parts.push(encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]));
      }
    }
  }
  return parts.join("&");
};

/**
 * Extract parameters from query string.
 * @param {string} search - The query string.
 * @returns {Object[]} - Object of the deconstructed query string
 */

export const getQueryStringParameters = search => {
  let hashes;
  if (typeof search === "undefined" || search === "") {
    return false;
  }
  hashes = search.slice(search.indexOf("?") + 1).split("&");
  return hashes.reduce((params, hash) => {
    let [key, val] = hash.split("=");
    if (typeof key === "undefined" || typeof val === "undefined") {
      return params;
    }
    return Object.assign(params, {
      [key]: decodeURIComponent(val.replace(/\+/g, " "))
    });
  }, {});
};